import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
export const selectTotalReports = ({ HolidayRequest_reducer }) => {
    return HolidayRequest_reducer.totalReports;
};
export const selectHolReqPostFail = ({ HolidayRequest_reducer }) => {
    return HolidayRequest_reducer.postHolReqFail;
};
export const selectHolidayRequests = createSelector(
    [selectTotalReports],
    reports => {
        if (reports === false || reports === null) {
            return undefined;
        }
        let holidayRequests = Object.keys(reports).map(e => {
            if (_.get(reports[e], "reports.holiday_request") === undefined) {
                return null;
            }
            let uid = e;
            let totalReports = _.get(reports[e], "reports.holiday_request");
            return Object.keys(totalReports).map(f => {
                let from_date = _.get(totalReports[f], "from_date") || null;
                let status = _.get(totalReports[f], "status");
                let submission_date = _.get(totalReports[f], "submission_date");
                let to_date = _.get(totalReports[f], "to_date");
                let username = _.get(totalReports[f], "username");
                return { uid, from_date, status, submission_date, to_date, username };
            });
        });

        holidayRequests = _.compact(holidayRequests);
        holidayRequests = _.flatten(holidayRequests);

        let sortedSelectedHolidays = holidayRequests.sort((a, b) => {
            a = new moment(a.submission_date, "DD/MM/YYYY hh:mm:ss"); //.format("DD/MM/YYYY hh:mm:ss");
            b = new moment(b.submission_date, "DD/MM/YYYY hh:mm:ss"); //.format("DD/MM/YYYY hh:mm:ss");
            return a.diff(b);
        });
        return sortedSelectedHolidays.reverse();
    }
);
